import React from 'react';

import { ReactComponent as XIcon } from '../../assets/icons/XIcon.svg';

import classes from './ExitProcess.module.scss';

const ExitProcess = ({ text, onClick }) => {
  return (
    <div className={`${classes.close} pointer`} onClick={onClick}>
      <XIcon className={classes.icon} />
      <span className={`${classes.color} ${classes['button-exit']}`}>{text}</span>
      <span className={`${classes.color} ${classes['button-exit-mobile']}`}>Salir</span>
    </div>
  );
};

export default ExitProcess;
